export default __webpack_public_path__ + "static/media/480_private01-fr-mobile.0e0b1903.png";